





























































import { defineComponent, ref, computed, watch } from "@vue/composition-api";
import useFetcher from "@/ts/functions/composition/useFetcher";
import PlaceCard from "../components/molecules/place/PlaceCard.vue";
import UserCard from "../components/molecules/card/UserCard.vue";
import { useGetters } from "vuex-composition-helpers";
import PlaceCreationVue from './Places/PlaceCreation.vue';
import PlaceModel from '@/ts/models/placeClass';

export default defineComponent({
  name: "MyNetwork",

  components: {
    PlaceCard,
    UserCard
  },

  setup() {
    var tab = ref(null);

    const { user } = useGetters({ user: "auth/user" } as any);

    var selectedSubject = ref(user.value)

    watch(() => selectedSubject.value, (newValue:any) => {
      console.log('yop')
    }, {deep:false});

    var { entity: userPlaces, loading: loading_userPlaces } = useFetcher(
      "place/GET_USER_PLACES"
    );

    var { entity: places, loading: loading_places } = useFetcher(
      "place/GET_LINKED_PLACES"
    );
    var { entity: users, loading: loading_users } = useFetcher(
      "user/GET_LINKED_USERS"
    );

    var networkSubjects:any = computed(() => {
      var array = [user.value]
      userPlaces.value?.forEach((place:PlaceModel) => {
        array.push(place)
      });
      return array
    })

    return {
      tab,
      places,
      loading_places,
      users,
      user,
      loading_users,
      networkSubjects,
      selectedSubject
    };
  }
});
